import { render, staticRenderFns } from "./workflow-bulk-enroller.vue?vue&type=template&id=22d2e5cd"
import script from "./workflow-bulk-enroller.vue?vue&type=script&lang=js"
export * from "./workflow-bulk-enroller.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports